import TemplateUtils from '../util/templateUtils';
import { xmlToJson, jsonToXml, getElementValue as getVal } from '../util/xmlUtils';
import { parseMosMessageXml } from '../util/mosUtils';
import {
  getTemplateDefinition as apiGetTemplateDefinition,
  createMosObject as apiInputMosObject
} from '../api/camio';
import { sendMosMessageToContainer } from '../api/container';

// eslint-disable-next-line
export const initApiListener = () => {
  if (window.addEventListener) {
    window.addEventListener('message', handleApiMessage, false);
  } else if (window.attachEvent) {
    window.attachEvent('message', handleApiMessage, false);
  }
};

const handleApiMessage = event => {
  if (!event.data) {
    return;
  }

  const parsedMessage =
    event.data && (typeof event.data === 'string' || event.data instanceof String)
      ? xmlToJson(event.data)
      : event.data;

  if (!parsedMessage || !parsedMessage.apiMessage) {
    return;
  }

  const apiMessage = getVal(parsedMessage.apiMessage);

  const mos = parseMosMessageXml(getVal(apiMessage));

  if (!mos) {
    return;
  }

  apiGetTemplateDefinition(mos.mosObjectId, 'mosobject', 2) // activeView is 2 hardcoded for now (1 for templates, 2 for mos)
    .then(json => {
      const templateDefinition = TemplateUtils.parseTemplateDefinition(
        json.templateDefinition,
        json.templateReplaceables
      );

      // Replace values, right now only automation.
      templateDefinition.properties['automation start'] =
        mos.automationStart || templateDefinition.properties['automation start'];
      templateDefinition.properties['automation duration'] =
        mos.automationDuration || templateDefinition.properties['automation duration'];

      // ToDo: updateMosObject
      updateMosObject(mos, templateDefinition);

      return Promise.resolve();
    })
    .catch(error => {
      console.log(error);
    });
};

const updateMosObject = (mos, templateDefinition) => {
  const requestData = {
    mosObjectObjectId: mos.mosObjectId || '',
    itemId: mos.id,
    ncsId: mos.ncsId,
    replaceables: (templateDefinition.textReplaceables || [])
      .concat(templateDefinition.mediaReplaceables)
      .map(r => ({
        id: r.id,
        name: r.name,
        type: r.type,
        value: r.value,
        provider: r.provider
      })),
    templateData: {
      automationTransition: templateDefinition.properties['automation transition'],
      channelName: templateDefinition.properties['default channel'],
      inTime: templateDefinition.properties['automation start'],
      outTime: templateDefinition.properties['automation duration'],
      slug: templateDefinition.properties['mos abstract']
    }
  };

  apiInputMosObject(requestData, 'update')
    .then(response => {
      const mosXmlPayload = getMosXmlPayload(response);
      if (mosXmlPayload) {
        sendMosMessageToContainer(mosXmlPayload.mosXml);
      }
      return Promise.resolve();
    })
    .catch(error => {
      console.log(error);
    });
};

const getMosXmlPayload = mosXml => {
  let mosXmlMassaged = null;
  if (mosXml && mosXml.length > 0) {
    const json = xmlToJson(mosXml, { mergeAttrs: false });
    if (json.generatemosobject.mos[0]) {
      mosXmlMassaged = jsonToXml(json.generatemosobject.mos[0], {
        rootName: 'mos',
        headless: true
      });
    }

    const parser = new DOMParser();
    const mosXmlParsed = parser.parseFromString(mosXmlMassaged, 'text/xml');
    return {
      objId: mosXmlParsed.evaluate(
        '//mosObj/objID/text()',
        mosXmlParsed,
        null,
        XPathResult.STRING_TYPE,
        null
      ).stringValue,
      title: mosXmlParsed.evaluate(
        '//mosAbstract/text()',
        mosXmlParsed,
        null,
        XPathResult.STRING_TYPE,
        null
      ).stringValue,
      mosXml: mosXmlMassaged
    };
  }
  return null;
};



// WEBPACK FOOTER //
// ./app/api/remoteControl.js